import SectionHeading from "./SectionHeading";
import { feeTiers } from "@/mocks/home";

export default function FeeSection() {
  return (
    <section id="fee" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          align="center"
          eyebrow="稿费结算"
          title="稿费怎么算，什么时候到账"
          desc="稿费与线索是否被采纳、信息增量大小、可核验程度直接相关，与文字长短无关。确认采纳后 3 个工作日内结算。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {feeTiers.map((tier) => (
            <article
              key={tier.name}
              className={`relative flex flex-col p-6 md:p-7 rounded-lg border ${
                tier.highlight
                  ? "bg-foreground-950 border-foreground-950"
                  : "bg-background-100 border-background-200"
              }`}
            >
              {tier.highlight && (
                <span className="absolute -top-3 left-6 inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  <i className="ri-fire-line"></i>
                  最多人关注
                </span>
              )}
              <h3
                className={`font-heading font-bold text-lg ${
                  tier.highlight ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {tier.name}
              </h3>
              <p
                className={`mt-4 font-heading font-black text-3xl ${
                  tier.highlight ? "text-accent-300" : "text-primary-700"
                }`}
              >
                {tier.price}
              </p>
              <p
                className={`mt-4 text-sm leading-relaxed flex-1 ${
                  tier.highlight ? "text-background-100/80" : "text-foreground-600"
                }`}
              >
                {tier.criteria}
              </p>
              <div
                className={`mt-6 pt-4 flex items-center gap-2 text-xs md:text-sm border-t ${
                  tier.highlight
                    ? "border-foreground-800 text-background-100/80"
                    : "border-background-200 text-secondary-700"
                }`}
              >
                <i className="ri-wallet-3-line text-base"></i>
                结算周期：{tier.cycle}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { icon: "ri-bank-card-line", text: "支持主流收款渠道，结算前与你确认" },
            { icon: "ri-file-shield-2-line", text: "结算信息仅财务与对接编辑可见" },
            { icon: "ri-forbid-2-line", text: "全程不收取任何形式的费用" },
          ].map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-3 p-4 rounded-lg bg-secondary-100 border border-secondary-200"
            >
              <span className="w-9 h-9 shrink-0 rounded-md flex items-center justify-center bg-background-50 text-secondary-700">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="text-sm text-secondary-900 leading-snug">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}